/**
 * State used in rendering DrawerBody
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
